let _regionId: string | null = null;

export const setRegionIdMe = (value: string | null) => {
  _regionId = value;
};

// Wait until _regionId is available
export const waitForRegionId = (): Promise<string> => {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (_regionId) {
        clearInterval(interval)
        resolve(_regionId)
      }
    }, 50) // check every 50ms
  })
}

export const getRegionId = ()=> _regionId;
